import { useState, useEffect, useRef } from "react";
import * as Mui from "@mui/material";
import { ArrowDropDown } from "@mui/icons-material";
import Popper from "@fragments/Popper";
import BaseInput from "../BaseInput";

const SelectInput = ({ value, onInput, label, placeholder, options = [], className, variant = 'light', ...props }) => {
    const [localValue, setLocalValue] = useState(value || "");
    const popperRef = useRef();
    const selectRef = useRef();
    const containerRef = useRef();

    useEffect(() => {
        setLocalValue(value || "");
    }, [value]);

    const handleOpenOptions = (event) => {
        if (props.disabled) return;
        event?.stopPropagation();

        const popperOptions = options.map((option, index) => ({
            id: `option-${index}`,
            label: option.label,
            icon: option.icon,
            disabled: option.disabled,
            onClick: async () => {
                setLocalValue(option.value);
                onInput(option.value);
                popperRef.current.close();
            }
        }));

        const targetElement = event?.currentTarget || containerRef.current || selectRef.current;
        popperRef.current.open(popperOptions, 'bottom', targetElement);
    };

    const selectedOption = options.find(option => option.value === localValue);

    const getDisplayValue = () => {
        return selectedOption ? selectedOption.label : placeholder || '';
    };

    const dropdownIcon = (
        <Mui.IconButton
            edge="end"
            onClick={handleOpenOptions}
            disabled={props.disabled}
            size="small"
            style={{ padding: '4px' }}
        >
            <ArrowDropDown />
        </Mui.IconButton>
    );

    return (
        <>
            <div
                ref={containerRef}
                onClick={handleOpenOptions}
                style={{ cursor: props.disabled ? 'not-allowed' : 'pointer' }}
                className="custom-select-input"
            >
                <BaseInput
                    ref={selectRef}
                    {...props}
                    value={getDisplayValue()}
                    start={selectedOption?.icon}
                    onInput={() => { }} // Prevent direct input
                    label={label}
                    placeholder={placeholder}
                    variant={variant}
                    className={className}
                    readOnly
                    end={dropdownIcon}
                    endAffix
                />
            </div>
            <Popper controlRef={popperRef} />
        </>
    );
};

export default SelectInput;
